import 'reflect-metadata'
import './fix'
import { createApp } from 'vue'
import App from './App.vue'
import router from './routers'
import './assets/css/main.scss'
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { startup } from '@eureka/startup'
import { accountDeferred } from '@eureka/utils/account';
import { headerService } from '@/services/header-service';
import { i18n } from '@/infrastructure/locales'
import _ from 'lodash'
import { container } from './inversify.config';
import { setContainer, ErrorHandler, ErrorHandlerRegistry, injectService } from '@patsnap/tahiti-core';
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
setContainer(container);
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();

window._ = _;

startup({
    headerService,
    projectName: 'eureka',
    agentName: UsageAmountWhere.IDEA,
    preset: {
        name: 'eureka',
    },
    pageInit() {
        return Promise.resolve()
    },
});

accountDeferred.promise.then(
    () => {
        import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
            getHelpCenter(i18n.global, headerService)
        })
    }
);

createApp(App).use(router).use(i18n).use(SafeHtmlPlugin).mount('#app');
